import BaseTooltip from 'components/BaseTooltip'
import PlusIcon from 'mdi-react/PlusIcon'
import React from 'react'

import { createStyles, Hidden, Theme } from '@mui/material'
import Fab from '@mui/material/Fab'
import { WithStyles, withStyles } from '@mui/styles'

const AddOrganizationButton: React.FunctionComponent<AddOrganizationButtonProps & WithStyles<typeof styles>> = ({
  classes,
  onClick,
}) => {
  const mobileButton = (
    <Hidden mdUp>
      <BaseTooltip title="Add Organization">
        <Fab color="secondary" aria-label="Add organization" className={classes.fabButton} onClick={onClick}>
          <PlusIcon />
        </Fab>
      </BaseTooltip>
    </Hidden>
  )

  return <>{mobileButton}</>
}

type AddOrganizationButtonProps = {
  onClick: () => any
}

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    buttonIcon: {
      fill: palette.secondary.contrastText,
      marginLeft: -spacing(0.5),
      marginRight: spacing(0.5),
    },
    fabButton: {
      position: 'fixed',
      zIndex: 10,
      right: spacing(2),
      bottom: spacing(2),
    },
  })

export default withStyles(styles)(AddOrganizationButton)
